// import React from 'react';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

// const DynamicTable = ({ data }) => {
//      if (!data || data.length === 0) return null;

//   return (
//      <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             {Object.keys(data[0]).map((key) => (
//               <TableCell key={key} sx={{ fontWeight: "bold" }}>
//                 {key}
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {data.map((row, rowIndex) => (
//             <TableRow key={rowIndex}>
//               {Object.keys(data[0]).map((key) => (
//                 <TableCell key={key}>{row[key]}</TableCell>
//               ))}
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   )
// }

// export default DynamicTable

import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const DynamicTable = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <TableContainer component={Paper} sx={{ border: "1px solid #e0e0e0" }}>
      <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
        <TableHead>
          <TableRow>
            {Object.keys(data[0]).map((key) => (
              <TableCell
                key={key}
                sx={{
                  fontWeight: "bold",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#f9f9f9",
                }}
              >
                {key}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {Object.keys(data[0]).map((key) => (
                <TableCell
                  key={key}
                  sx={{
                    border: "1px solid #e0e0e0",
                    verticalAlign: "top",
                  }}
                >
                  {row[key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DynamicTable;
